import React from "react";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";

interface LoadingStateProps {
  message?: string;
  showSpinner?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading data...",
  showSpinner = true,
}) => {
  return (
    <div style={{ width: "100%", marginTop: "-30px", marginBottom: "-30px" }}>
      <Card className="p-4">
        <div className="text-center">
          {showSpinner && (
            <div className="mb-3">
              <ProgressSpinner style={{ width: "50px", height: "50px" }} />
            </div>
          )}
          <h3>{message}</h3>
          <p>Please wait while we fetch the latest information.</p>
        </div>
      </Card>
    </div>
  );
};

export default LoadingState;
